<template>
  <div id="personal-view">
    <transition name="sub-view" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      questionIndex: 0
    }
  },
  methods: {
  },
  computed: {
    ...mapGetters([])
  }
}
</script>

<style lang="scss">
.card--text {
  color: var(--white);
  background-color: #ff8e72;
}
</style>
